<div style="margin-top:30px;margin-left:30px;">

    <mat-tab-group>
        <mat-tab label="Market">
            
            <!-- <button (click)="OnLaunchSnackBar()">Launch Snack Bar</button><br />
<button  (click)="OnKillSnackBar()">Kill Snack Bar</button><br/> -->

<igx-grid [batchEditing]="true" #gridProfile [data]="marketRate" [width]="'99%'" [height]="'2000px;'" [autoGenerate]="false" style=margin-left:10px;margin-top:10px;
paste-handler  [primaryKey]="'rateNumber'" [rowEditable]="false" [allowFiltering]="true"  filterMode="excelStyleFilter" displayDensity="compact" 
[emptyGridMessage]="'Market Rate Empty'"   >

<!-- <igx-column field="companyId" header="Company Id*" [sortable]="true" width="250px" required ></igx-column> -->
<!-- <igx-column field="view" header=" " width="50px" required ></igx-column>


<igx-column field="active" header=" " [sortable]="true" width="35px" required style="font-size:10px;"  [resizable]="true"></igx-column> -->


<igx-column field="rateNumber" header="Rate No." [sortable]="true" width="250px" [resizable]="true">
    <!-- <ng-template #compositeTemp igxCell let-cell="cell">
            {{cell.row.data.companyName}} 
            <div style="position:relative;top:-5px;margin-left:5px;">
            <button mat-icon-button aria-label="Copy Company Id"  matTooltip="Copy Company Name">
                <mat-icon>content_copy</mat-icon>
            </button>
            </div>
    </ng-template> -->
</igx-column>

<igx-column field="stallType" header="Type" [sortable]="true" width="250px"  [resizable]="true">
    <!-- <ng-template #compositeTemp igxCell let-cell="cell">
            {{cell.row.data.billingAddress1}}
            @if(cell.row.data.billingAddress2 != ''){
                <br />{{cell.row.data.billingAddress2}}
            }
            @if(cell.row.data.billingCity != '' || cell.row.data.billingState != '' || cell.row.data.billingZipCode != ''){
                <br />{{cell.row.data.billingCity}} {{cell.row.data.billingState}} {{cell.row.data.billingZipCode}}
            }

            @if(cell.row.data.billingPhone != '' ){
                <br />{{cell.row.data.billingPhone}} 
            }
            <br />
    </ng-template> -->
</igx-column>

<igx-column field="description" header="Description" [sortable]="true" width="150px"  [resizable]="true"></igx-column>

<igx-column field="startDate" header="Start Date" [sortable]="true" width="250px"  [resizable]="true">
    <!-- <ng-template #compositeTemp igxCell let-cell="cell">
        
        @if(cell.row.data.emailAddress != '' && cell.row.data.emailAddress != null){
            {{cell.row.data.emailAddress}} 
            <div style="position:relative;top:-5px;margin-left:5px;">
            <button mat-icon-button aria-label="Copy Company Id"  matTooltip="Copy Company Primary Email">
                <mat-icon>content_copy</mat-icon>
            </button>
            </div>
        }
        
    </ng-template> -->
</igx-column>

<igx-column field="endDate" header="End Date" [sortable]="true" width="100px"  [resizable]="true"></igx-column>


<igx-column field="netRate" header="netRate" [sortable]="true" width="100px"  [resizable]="true">
   
</igx-column>


<igx-column field="grossRate" header="grossRate" [sortable]="true" width="100px"   [resizable]="true">
  
</igx-column>

<igx-column field="quantity" header="Qty" [sortable]="true" width="150px"   [resizable]="true">
   

</igx-column>

<igx-column field="isPortal" header="Portal" [sortable]="true" width="150px"   [resizable]="true">
   

</igx-column>


<ng-template igxGridDetail let-dataItem style="margin-top:20px;height:300px;width:1000px;"  >
    <igx-tabs #tabs [selectedIndex]="0" style="width:100%;">
        <igx-tab-item>
            <igx-tab-header>
                <span class="ace-heading-text-grid-tabs">Expired Rates</span>
            </igx-tab-header>
            <igx-tab-content style="height:600px;margin-bottom:10px;margin-top:10px;width:100%">
             
                <!-- <app-company-detail [companyDetail]="dataItem"></app-company-detail> -->
            </igx-tab-content>
        </igx-tab-item>
        <igx-tab-item>
            <igx-tab-header>
                <span class="ace-heading-text-grid-tabs">Future Rate(s)</span>
            </igx-tab-header>
            <igx-tab-content  style="height:600px;">
               <!-- <app-additional-contacts-company-component [companyDetail]="dataItem"></app-additional-contacts-company-component> -->
            </igx-tab-content>
        </igx-tab-item>

        <igx-tab-item>
            <igx-tab-header>
                <span class="ace-heading-text-grid-tabs">Companies</span>
            </igx-tab-header>
            <igx-tab-content  style="height:800px;">
               <!-- <app-company-space-email [companyDetail]="dataItem"></app-company-space-email> -->
            </igx-tab-content>
        </igx-tab-item>
    </igx-tabs>
</ng-template>



    <igx-grid-toolbar>
        <igx-grid-toolbar-actions>
            <igx-grid-toolbar-pinning></igx-grid-toolbar-pinning>
            <igx-grid-toolbar-hiding></igx-grid-toolbar-hiding>
            <!-- <igx-grid-toolbar-exporter></igx-grid-toolbar-exporter> -->
        </igx-grid-toolbar-actions>

    </igx-grid-toolbar>

</igx-grid>

            
            
        </mat-tab>
        <mat-tab label="Company">
             Content 2 
            
        </mat-tab>
        <mat-tab label="Rate/Lot Settings">
             Content 3 
        </mat-tab>
      </mat-tab-group>


</div>
